import React, { Component } from 'react';

import Modal from '../../../UI/Modal/Modal';
import Button from '../../../UI/Button/Button';
import Input from '../../../UI/Input/Input';
import InputError from '../../../UI/InputError/InputError';
import Spinner from '../../../UI/Spinner/Spinner';
import NavbarElement from '../../../Navigation/Navbar/NavbarElement/NavbarElement';
import AlertError from '../../AlertError/AlertError';
import strings from '../../../../assets/localization';
import classes from './NewPassword.module.css';

class NewPassword extends Component {
  state = { isPasswordShort: true }

  constructor (props) {
    super(props);
    this.state = {
      focus: false
    };
  }


  focusedInput = () => {
    if (!this.state.focus) {
      this.setState({ focus: true });
    }
  };
  discardFocusedInput = () => {
    if (this.state.focus) {
      this.setState({ focus: false });
    }
  };
  _onPasswordChange = (event) => {
    const { target: { value } } = event;
    // this.setState({ password: value });
    this.props.setPassword(value);
    const passwordLength = value.length;
    if (passwordLength === 6) {
      this.setState({isPasswordShort: false});
    }
  }
  _isValidPassword = () => {
    return this.props.password.length >= 6;
  }
  _renderPasswordError = () => {
    return <InputError style={{display: !this.state.isPasswordShort && !this._isValidPassword() ? 'block' : 'none'}}>{strings.passwordError}</InputError>;
  }
  _onEmailKeyPress = event => {
    if (event.charCode === 13 && this._isValidPassword()) {
      // submit new password on Enter key
      this.props.submitNewPassword();
    }
  };
  _renderSpinner = () => {
    return (
      <div className={classes.SpinnerWrapper}>
        <Spinner size='Tiny' />
      </div>
    );
  };

  render () {
    let modalStyle = null;
    if (this.props.isLandscape) {
      modalStyle = {minHeight: 'auto', height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center'};
    }

    return (
      <Modal
        modalStyle={modalStyle}
        navbarLeftElement={
          <NavbarElement
            fill='var(--svg-color-navigation-light)'
            imgIcon='/sprites.svg#icon-close-small'
            alt={strings.Close}
            clicked={this.props.close}
          />
        }
        navbarCenterElement={strings.recoveryTittle}
      >
        <div className={classes.Content}>
          <Input
            type='password'
            onFocus={this.focusedInput}
            onBlur={this.discardFocusedInput}
            value={this.state.password}
            onChange={this._onPasswordChange}
            label={`${strings.NewPassword}:`}
            onKeyPress={this._onEmailKeyPress}
            placeholder={strings.EnterPassword}
            maxLength={128}
          />
          {this._renderPasswordError()}
        </div>
        <div className={classes.FooterWrapper}>
          <div className={this.state.focus ? classes.Focused : classes.Footer}>
            <Button
              disabled={!this._isValidPassword() || this.props.showSpinner}
              clicked={this.props.submitNewPassword}
            >{strings.SetNewPassword}
            </Button>
          </div>
          {this.props.showSpinner ? this._renderSpinner() : null}
        </div>
        {this.props.showErrorAlert ? <AlertError dismissAlert={this.props.toggleAlertError} errorMessage={this.props.emailErrorMessage} /> : null}
      </Modal>
    );
  }
}

export default NewPassword;



// WEBPACK FOOTER //
// ./src/components/Auth/PasswordRecovery/NewPassword/NewPassword.js